import React, { useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Alert from '../../components/alert/Alert'

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [alertState, setAlertState] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const emailRef = useRef();
  const navigate = useNavigate();

  const setAlert = (severity, message) => {
    setAlertState(true);
    setAlertSeverity(severity);
    setAlertMessage(message);
  };

  const clearAlert = () => {
    setAlertState(false);
    setAlertSeverity('');
    setAlertMessage('');
  };

  const handleSubmit = () => {
    setLoading(true);

    setLoading(false);
  }

  return (
    <div className="App-container">
      <div className="bg-white-900 dark:bg-white-900 w-full">
        <div className="items-center px-8 py-8 my-10 mx-auto w-fit">
          <div className="max-w-sm border-2 rounded-md mx-auto my-20 p-4 shadow-lg">
            <h2 className='text-center mb-4 font-bold text-2xl text-black'>Forgot Password</h2>
            {alertState && <Alert alertSeverity={alertSeverity}
              alertMessage={alertMessage}
              onClose={() => clearAlert()} />}
            <form className='mb-2' onSubmit={handleSubmit}>
              <div className='flex flex-col py-2 text-center'>
                <label className='py-2 text-base text-black'>Email</label>
                <input
                  className='border-2 rounded-md text-center text-black'
                  ref={emailRef}
                  type='email' />
              </div>
              <button
                className='border rounded-md border-blue-500
              bg-main-purple hover:bg-primary-300 w-full 
                p-4 my-2 text-center text-white text-base'
                type='submit'
                disabled={loading}
              >
                Reset Password
              </button>
              <button
                className='border rounded-md border-blue-500
              bg-main-purple hover:bg-primary-300 w-full 
                p-4 my-2 text-center text-white text-base'
                onClick={() => navigate('/')}
                disabled={loading}
              >
                Cancel
              </button>              
            </form>
            <div className="flex-grow h-px bg-gray-400"></div>
            <div className='w-100 text-center mt-6 text-gray-500 text-base'>
              Already have an account? <Link className='underline text-blue-500' to='/sign-in'>Sign In</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
